import UserContext from './UserContext';
import { useState } from 'react';

const UserState = (props) => {
    const [updateddata, setUpdateddata] = useState(false)

    return (
        <UserContext.Provider value={{ updateddata, setUpdateddata }}>
            {props.children}
        </UserContext.Provider>
    )
}

export default UserState;